import * as actionTypes from "../../actions/actionTypes";
import { updateObject } from "../../shared/utility";


const initialState = {
  roles: [],
  loading: false,
  roleDetails: {}
};
const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.SET_LOADING:
      return updateObject(state, {
        loading: action.payload
      });

    case actionTypes.GET_ALL_ROLES:
      return updateObject(state, {
        roles: action.payload
      });

    case actionTypes.GET_ROLE_BY_ID:
      return updateObject(state, {
        roleDetails: action.payload,
        loading: false,
      });

    default:
      return state;
  }
};

export default reducer;